import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { QuizState } from "@/models/QuizState"

export default {
	namespaced: true,
	state: (): QuizState => {
		return null
	},
	mutations,
	actions,
	getters
}
